'use strict';

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var PaymentIFrameHost = require('../payments/PaymentIFrameHost');
var LocalizationMixin = require('../../localization/CommonLocalizationMixin');
var sessionUtility = require('../../lib/sessionUtility');

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizationMixin],
    propTypes: {
        user: PropTypes.object.isRequired,
        helper: PropTypes.object.isRequired,
        hideModal: PropTypes.func.isRequired,
        addCardAnalytics: PropTypes.func.isRequired,
        showLoadingSpinner: PropTypes.func.isRequired,
        hideLoadingSpinner: PropTypes.func.isRequired,
        onSuccess: PropTypes.func.isRequired,
        onError: PropTypes.func,
        coords: PropTypes.object
    },
    getInitialState: function getInitialState() {
        return {
            errors: []
        };
    },
    hideModal: function hideModal() {
        this.props.hideModal();
    },
    getQueryStrings: function getQueryStrings(extraParams) {
        var user = this.props.user;
        var params = this.props.helper.getQuerystringValues();
        var qs = [];
        for (var param in params) {
            qs.push(param + '=' + params[param]);
        }
        if (extraParams) {
            for (var param in extraParams) {
                qs.push(param + '=' + extraParams[param]);
            }
        }
        qs.push('t=' + user.token);
        qs.push('d=' + user.deviceId);
        return '?' + qs.join('&');
    },
    onSuccess: function onSuccess() {
        this.props.addCardAnalytics();
        this.props.onSuccess();
    },
    onFail: function onFail(errors) {
        var _this = this;

        this.setState({ errors: [] }, function () {
            _this.setState({ errors: errors });
            if (typeof _this.props.onError === 'function') {
                sessionUtility.evaluateRedirectToLoginOnSessionExpiration({ serviceMessages: errors }, function () {
                    _this.props.onError();
                    _this.props.hideModal();
                });
            }
        });
    },
    handleIFrameOnLoad: function handleIFrameOnLoad() {
        document.querySelector('iframe').contentWindow.focus();
    },
    handleBeginningFocusTrap: function handleBeginningFocusTrap() {
        document.querySelector('iframe').contentWindow.focus();
    },
    handleEndingFocusTrap: function handleEndingFocusTrap() {
        document.querySelector('#offer-modal-close-btn').focus();
    },
    handleKeyDown: function handleKeyDown(e) {
        if (e.keyCode === 27) {
            this.hideModal();
        }
    },
    render: function render() {
        var queryString = this.getQueryStrings(this.props.coords);
        var Config = require('../../lib/config').urls;

        return React.createElement(
            'div',
            { className: 'qa-add-card-modal', role: 'dialog', 'aria-labelledby': 'add-card-modal-title', onKeyDown: this.handleKeyDown },
            React.createElement('div', { className: 'sr-only', tabIndex: '0', onFocus: this.handleBeginningFocusTrap }),
            React.createElement(
                'div',
                { className: 'modal-header' },
                React.createElement(
                    'button',
                    { type: 'button', className: 'close', onClick: this.hideModal, id: 'offer-modal-close-btn' },
                    React.createElement(
                        'span',
                        { 'aria-hidden': 'true' },
                        '\xD7'
                    ),
                    React.createElement(
                        'span',
                        { className: 'sr-only' },
                        this.getLocalizedText('payment_options_close')
                    )
                )
            ),
            React.createElement(
                'div',
                { className: 'modal-body' },
                React.createElement(
                    'div',
                    { className: 'row' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12', 'aria-live': 'assertive' },
                        this.state.errors.map(function (error, i) {
                            return React.createElement(
                                'p',
                                { key: 'add_card_modal_error_' + i, className: 'bg-danger', 'aria-atomic': 'true' },
                                error
                            );
                        })
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'row' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        React.createElement(
                            'h1',
                            { id: 'add-card-modal-title' },
                            this.getLocalizedText('payment_options_add_new_card')
                        ),
                        React.createElement('hr', null)
                    ),
                    React.createElement(
                        'div',
                        { className: 'col-xs-12', id: 'add-card-modal-iframe' },
                        React.createElement(PaymentIFrameHost, {
                            url: Config.paymentBaseUrl + 'pages/www/saveCreditCard.html' + queryString,
                            successCallback: this.onSuccess,
                            errorCallback: this.onFail,
                            ajaxStopCallback: this.props.hideLoadingSpinner,
                            ajaxStartCallback: this.props.showLoadingSpinner,
                            onLoad: this.handleIFrameOnLoad
                        }),
                        React.createElement('div', { className: 'sr-only', tabIndex: '0', onFocus: this.handleEndingFocusTrap })
                    )
                )
            )
        );
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/modals/addCardModal.js
// module id = 831
// module chunks = 0